import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PUP: TStep[] = [
  {
    pageId: PageId.DOG_AGE_PUP,
  },
  {
    pageId: PageId.DOG_OWNER_PUP,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_PUP,
  },
  {
    pageId: PageId.URGE_PAGE_PUP,
  },
  {
    pageId: PageId.DOG_BREED_PUP,
  },
  {
    pageId: PageId.FACING_CHALLENGES_PUP,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_PUP,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_PUP,
  },
  {
    pageId: PageId.URGE_PROGRAM_PUP,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_PUP,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_PUP,
  },
  {
    pageId: PageId.URGE_PAGE_4_PUP,
  },
  {
    pageId: PageId.COMMANDS_PUP,
  },
  {
    pageId: PageId.PARENT_GOAL_PUP,
  },
  {
    pageId: PageId.TRAINING_PLACE_PUP,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_PUP,
  },
  {
    pageId: PageId.URGE_PAGE_5_PUP,
  },
  {
    pageId: PageId.PREPARE_FLOW_PUP,
  },
  {
    pageId: PageId.EMAIL_PUP,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PUP,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_PUP,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PUP,
  },
  {
    pageId: PageId.CHAT_UPSELL_PUP,
  },
  {
    pageId: PageId.UPSELL_PUP,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PUP,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PUP,
  },
  {
    pageId: PageId.DOWNLOAD_PUP,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP,
  PageId.FACING_CHALLENGES_2_PUP,
  PageId.DOG_BREED_PUP,
  PageId.BEHAVIOR_FEELINGS_PUP,
  PageId.FIX_BEHAVIOR_PUP,
  PageId.PARENT_GOAL_PUP,
  PageId.TRAINING_PLACE_PUP,
  PageId.TRAINING_FREQUENCY_PUP,
]

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP,
  PageId.FACING_CHALLENGES_2_PUP,
  PageId.DOG_BREED_PUP,
  PageId.BEHAVIOR_FEELINGS_PUP,
  PageId.FIX_BEHAVIOR_PUP,
  PageId.PARENT_GOAL_PUP,
  PageId.TRAINING_PLACE_PUP,
  PageId.TRAINING_FREQUENCY_PUP,
]
